import React from 'react'
import { Box } from '@mui/material'
import SectionTitle from '@/components/Common/SectionTitle'
import { getImageCsCart } from '@/lib/getImageCsCart'
import { getLinkBannerUrl } from '@/lib/getLinkBannerUrl'
import Image from 'next/image'
import Link from '@/components/Common/Link'
import Carousel from 'react-multi-carousel'
import Pagination from '../Dots/Pagination'
import { useRestQuery } from '@/lib/hook/tanstackQuery'
import Banner from '@/type/banner'
import { DefaultError } from '@tanstack/react-query'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'

const CustomButtonGroup = ({ totalItems, goToSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest

  const handleStepChange = (step: number) => {
    goToSlide(step)
  }
  return (
    <Pagination
      dots={totalItems}
      index={currentSlide - totalItems}
      onChangeIndex={handleStepChange}
    />
  )
}

const CarrouselBanner = () => {
  const { data, isLoading } = useRestQuery<{ banners: Banner[] }, DefaultError>({
    ...ApiQueryEndpoint.CMS.GET_BANNERS,
    queriesParams: { type: 'Q' },
  })

  if (isLoading || !data || data?.banners?.length === 0) return null

  const dataBanners = data?.banners
  const breakpoint = { max: 1024, min: 464 }

  const bannersDisplay = dataBanners.map(brand => (
    <Box
      key={brand.banner_id}
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ height: '100%', margin: '0 10px' }}>
        <Link href={getLinkBannerUrl(brand.url)} passHref>
          <Image
            src={getImageCsCart(brand.main_pair)}
            alt={brand.banner}
            width={330}
            height={170}
            style={{
              maxWidth: '100%',
              height: '100%',
              borderRadius: 16,
            }}
          />
        </Link>
      </Box>
    </Box>
  ))

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#FFF',
        py: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SectionTitle>Laboratoires tendances</SectionTitle>
      <Box
        sx={{
          width: '100%',
          maxWidth: '2000px',
          justifyContent: 'space-between',
        }}
      >
        <Carousel
          key={`Q_New_${dataBanners.length}`}
          additionalTransfrom={0}
          arrows={false}
          showDots={false}
          ssr={true}
          autoPlay
          autoPlaySpeed={3000}
          centerMode={false}
          className={'h-56 !items-start'}
          containerClass="container-with-dots"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
          //@ts-ignore
          customButtonGroup={<CustomButtonGroup totalItems={dataBanners.length} />}
          responsive={{
            desktop: {
              breakpoint: {
                max: 3000,
                min: 1024,
              },
              items: Math.min(dataBanners.length, 4),
              partialVisibilityGutter: 40,
            },
            mobile: {
              breakpoint: {
                max: 464,
                min: 0,
              },
              items: Math.min(dataBanners.length, 1),
              partialVisibilityGutter: 30,
            },
            tablet: {
              breakpoint: breakpoint,
              items: Math.min(dataBanners.length, 3),
              partialVisibilityGutter: 30,
            },
          }}
        >
          {bannersDisplay}
        </Carousel>
      </Box>
    </Box>
  )
}

export default CarrouselBanner
